import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const SVG_EXPAND = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>`;
const SVG_COMPRESS = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="10" y1="14" x2="3" y2="21"/><line x1="21" y1="3" x2="14" y2="10"/></svg>`;

export default function FullscreenControl() {
  const map = useMap();

  useEffect(() => {
    let active = false;
    const container = map.getContainer();

    const control = L.control({ position: "topright" });
    control.onAdd = () => {
      const wrap = L.DomUtil.create("div", "leaflet-bar leaflet-control");
      const btn = L.DomUtil.create("a", "", wrap);
      btn.href = "#";
      btn.title = "Pantalla completa";
      btn.style.cssText =
        "display:flex;align-items:center;justify-content:center;width:30px;height:30px;color:#555;";
      btn.innerHTML = SVG_EXPAND;

      L.DomEvent.on(btn, "click", (e) => {
        L.DomEvent.preventDefault(e);
        active = !active;
        container.classList.toggle("map-fullscreen", active);
        btn.innerHTML = active ? SVG_COMPRESS : SVG_EXPAND;
        setTimeout(() => map.invalidateSize(), 150);
      });

      L.DomEvent.disableClickPropagation(wrap);
      return wrap;
    };

    control.addTo(map);

    const onKey = (e) => {
      if (e.key === "Escape" && active) {
        active = false;
        container.classList.remove("map-fullscreen");
        setTimeout(() => map.invalidateSize(), 150);
      }
    };
    document.addEventListener("keydown", onKey);

    return () => {
      control.remove();
      document.removeEventListener("keydown", onKey);
    };
  }, [map]);

  return null;
}
